import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { tt } from '@i18n/tt';

import { PortalConfigSelector } from 'store/config/selectors';
import { CHAT } from 'router/routes';

import { ReactComponent as ArrowIcon } from 'assets/arrowForward.icon.svg';
import { ReactComponent as MessageIcon } from 'assets/message.svg';

import Button from 'components/Button/Button';
import CreateChatDialog from 'pages/Chats/dialogs/CreateChatDialog';
import ChatWithSupport from 'pages/Chats/dialogs/ChatWithSupport';

import useStyles from '../styles';

const CreateChatArea: FC = () => {
  const [openCreateChatDialog, setOpenCreateChatDialog] = useState<boolean>(false);

  const { useHelpdeskAi } = useSelector(PortalConfigSelector);
  const classes = useStyles();
  const config = useSelector(PortalConfigSelector);
  const navigate = useNavigate();

  if (config.disableChats) return null;

  return (
    <div className={classes.homePageTile}>
      <div className={classes.text}>
        <Button
          text={tt('pages.home.chartCard.button')}
          onClick={() => {
            setOpenCreateChatDialog(true);
          }}
          startIcon={<MessageIcon />}
          endIcon={<ArrowIcon />}
          variant="text"
          fullWidth
          className={classes.button}
        />
      </div>

      {openCreateChatDialog && !useHelpdeskAi && (
        <CreateChatDialog
          open={openCreateChatDialog}
          onClose={() => {
            setOpenCreateChatDialog(false);
          }}
          onSubmit={chatId => {
            navigate(CHAT.replace(':chatId', chatId.toString()));
          }}
        />
      )}
      {openCreateChatDialog && useHelpdeskAi && (
        <ChatWithSupport
          MSBot={false}
          open={openCreateChatDialog}
          onClose={() => {
            setOpenCreateChatDialog(false);
          }}
        />
      )}
    </div>
  );
};

export default CreateChatArea;
